import { delay } from 'redux-saga';
import { call, takeEvery } from 'redux-saga/effects';

import * as types from './types';

export function *doSomethingAsync() {
    yield call(delay, 1000);

    console.log('Something async is done');
}

export default function *watchCommentsAsync() {
    yield takeEvery(types.INCREASE_COUNTER, doSomethingAsync);
}
